import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import bannerImg1 from "../../assets/homeAssets/bannerImg1.webp";
import bannerImg2 from "../../assets/homeAssets/bannerImg2.png";
import bannerImg3 from "../../assets/homeAssets/bannerImg3.webp";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Banner = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Swiper
        className="swiper leftSwiper"
        pagination={true}
        modules={[Pagination, Autoplay]}
        slidesPerView={"auto"}
        spaceBetween={20}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3700,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide className="slide">
          <div className="gradient"></div>
          <img src={bannerImg1} alt="" />
          <div className="text">
            <h1>{t("bannerT1")}</h1>
            <p>{t("bannerS1")}</p>
            <div className="btns">
              <Link to={"/prints"}>
                <button>{t("seeMore")}</button>
              </Link>
              {/* <button>See More</button> */}
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="slide slide2">
          <div className="gradient"></div>
          <img src={bannerImg2} alt="" />
          <div className="text">
            <h1>{t("bannerT2")}</h1>
            <p>{t("bannerS2")}</p>
            <div className="btns">
              <Link to={"/prints"}>
                <button>{t("seeMore")}</button>
              </Link>
              {/* <button>See More</button> */}
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="slide">
          <div className="gradient"></div>
          <img src={bannerImg3} alt="" />
          <div className="text">
            <h1>{t("bannerT3")}</h1>
            <p>{t("bannerS3")}</p>
            <div className="btns">
              <Link to={"/prints"}>
                <button>{t("seeMore")}</button>
              </Link>
              {/* <button>See More</button> */}
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </Container>
  );
};
const Container = styled.div`
  padding: 80px 0%;
  background: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  .swiper {
    display: flex;
    height: 81vh;
    .slide {
      position: relative;
      justify-content: center;
      width: 90%;
      display: flex;
      align-items: center;
      gap: 3em;
      height: 80vh;
      padding: 3em 4em;
      box-shadow: 0 0px 10px 1px var(--shadowColor);
      .gradient {
        width: 100%;
        height: 80vh;
        position: absolute;
        background: var(--bgTextGradient);
        z-index: 1;
      }
      img {
        position: absolute;
        z-index: 0;
        height: 80vh;
        object-fit: cover;
        width: 100%;
      }
      .text {
        z-index: 1;
        width: 50%;
        justify-content: left;
        position: absolute;
        left: 7%;
        h1 {
          font-size: 6vw;
          font-family: "Josefin Sans", sans-serif;
        }
        p {
          font-weight: 300;
          color: var(--fontSecondaryColor);
        }
        .btns {
          display: flex;
          gap: 10px;
          margin-top: 1em;
          button {
            background-color: var(--fontPrimaryColor);
            border: none;
            color: var(--primaryBackgroundColor);
            padding: 7px 14px;
            font-size: 18px;
            border-radius: 20px;
            font-family: "Poppins", cursive;
            cursor: pointer;
            transition: 0.4s;
            :hover {
              box-shadow: 0 0 14px 2px var(--shadowColor);
            }
          }
          :nth-child(2) {
            color: var(--fontPrimaryColor);
            background: var(--secondaryBackgroundColor);
          }
        }
      }
    }
    .slide2 {
      .text {
        text-align: end;
        justify-content: end;
        left: 44%;
        position: absolute;
        width: 50%;
      }
      .btns {
        justify-content: end;
      }
      .gradient {
        background: var(--bgTextGradientRight);
      }
    }
  }
  .swiper-pagination {
    width: 100%;
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
  }

  .swiper-pagination-bullet {
    width: 24px;
    height: 7px;
    background-color: #ffffff; /* Change to your desired color */
    opacity: 0.7;
    margin: 0 5px;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 0 0 3px 1px gray;
    transition: background-color 0.3s ease;
  }

  .swiper-pagination-bullet-active {
    background-color: #554f4f; /* Change to your desired active color */
    opacity: 1;
  }
  @media (max-width: 750px) {
    .swiper {
      .slide {
        .text {
          width: 70%;
          h1 {
            font-size: 8vw;
          }
        }
      }
      .slide2 {
        .text {
          left: 20%;
        }
      }
    }
  }
  @media (max-width: 520px) {
    .swiper {
      height: 60vh;
      .slide {
        height: 60vh;
        .text {
          width: 90%;
          h1 {
            font-size: 3em;
          }
        }
      }
      .slide2 {
        .text {
          left: 2%;
        }
      }
    }
  }
`;

export default Banner;
